import React from 'react'
import PropTypes from 'prop-types'
import DropDownList from './DropDownList'

const Dropdown = (props) => {
  return (
    <li className="navbar-profile nav-item-icon navbar-with-dropdown">
      <a href="javascript:;" className="navbar-link" onClick={props.toggleWithId}>
        {props.linkComponent}
      </a>
      <DropDownList
        navList={props.dropDownList}
        id={props.id}
        dropdown={props.dropdown}
        locale={props.locale} />
    </li>
  )
}

Dropdown.propTypes = {
  id: PropTypes.string,
  toggleWithId: PropTypes.func,
  dropdown: PropTypes.string
}

export default Dropdown



// WEBPACK FOOTER //
// ./assets/js/components/navigations/dropdowns/Dropdown.jsx